import React from 'react';

import { ContainerData } from './styles';
import { useFilterGlobal } from '../../../hooks/useFilterGlobal';
import ControlledComponent from '../../InputDataPicker';
import Text from 'components/Text';

const FilterDate = () => {
  const { rangeDate, handleRangeDate } = useFilterGlobal();
  return (
    <ContainerData>
      <Text size="medium" bold color="yellow">
        Filtrar por data
      </Text>
      <ControlledComponent
        onChange={(date: string) =>
          handleRangeDate({ initial_date: date, end_date: rangeDate.end_date })
        }
        defaultValue={rangeDate.initial_date || undefined}
      />
      <ControlledComponent
        onChange={(date: string) =>
          handleRangeDate({ initial_date: rangeDate.initial_date, end_date: date })
        }
        defaultValue={rangeDate.end_date || undefined}
      />
    </ContainerData>
  );
};

export default FilterDate;
